"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceDefaultsProvider = void 0;
const React = __importStar(require("react"));
const split_screen_types_1 = require("../../components/split-screen/split-screen-types");
const evidence_defaults_context_1 = require("./evidence-defaults-context");
function EvidenceDefaultsProvider({ children, appName, appLogo, sortMissingValues = 'LAST', entityLocking, enableEmptyDetailContainer, enableFilterBox, reloadDetailOnUpdate, onDetailUpdate, panelUnmountOnExit, splitScreen = split_screen_types_1.SplitScreenMode.SPLIT, ToolbarComponent, ToolbarButtonComponent, ContainerComponent, EmptyContainerComponent, FieldsComponent, GeneralFieldsComponent, }) {
    const context = React.useMemo(() => ({
        name: appName,
        logo: appLogo,
        sortMissingValues,
        entityLocking,
        enableEmptyDetailContainer,
        enableFilterBox,
        reloadDetailOnUpdate,
        onDetailUpdate,
        panelUnmountOnExit,
        splitScreen,
        ToolbarComponent,
        ToolbarButtonComponent,
        ContainerComponent,
        EmptyContainerComponent,
        FieldsComponent,
        GeneralFieldsComponent,
    }), [
        appName,
        appLogo,
        sortMissingValues,
        entityLocking,
        enableEmptyDetailContainer,
        enableFilterBox,
        reloadDetailOnUpdate,
        onDetailUpdate,
        panelUnmountOnExit,
        splitScreen,
        ToolbarComponent,
        ToolbarButtonComponent,
        ContainerComponent,
        EmptyContainerComponent,
        FieldsComponent,
        GeneralFieldsComponent,
    ]);
    return (React.createElement(evidence_defaults_context_1.EvidenceDefaultsContext.Provider, { value: context }, children));
}
exports.EvidenceDefaultsProvider = EvidenceDefaultsProvider;
//# sourceMappingURL=evidence-defaults-provider.js.map